import { createAnalyticsMiddleware, getConfigValue, tokenIsExpired, AuthService } from '@indigo-ag/ui-core';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { actionsToTrack } from './actionsToTrack';
import createReducers from './reducers';
import rootSaga from './sagas';
import { AppState } from './state';

// Create the store with the middlewares
//  1. routerMiddleware: Syncs the location/URL path to the state
const configureStore = (initialState?: AppState): Store<AppState> => {
  const sagaMiddleware = createSagaMiddleware();

  // Build the middleware for intercepting and dispatching navigation actions
  const middlewares = [sagaMiddleware, createAnalyticsMiddleware(actionsToTrack)];

  const enhancers = [applyMiddleware(...middlewares)];

  // Add the reducer to the store on the `router` key
  // Add the Apollo reducer to the store on the `apollo` key
  // Also apply the middleware for navigating
  const globalStore = createStore(createReducers(), initialState, composeWithDevTools(...enhancers));

  // Extensions
  sagaMiddleware.run(rootSaga);

  return globalStore;
};

// Create a history of your choosing (we're using a browser history in this case)
let historyOptions = {};

if (getConfigValue('PUBLIC_URL')) {
  historyOptions = { basename: getConfigValue('PUBLIC_URL') };
}

const isAuthenticated = !tokenIsExpired(AuthService.getIdToken());
// Create store
const store = configureStore({ auth: { loggedIn: isAuthenticated }, layout: { menu: { menuIsOpen: false } } });

const history = createBrowserHistory(historyOptions);

// Once we decouple 'client' consumers should import it outside of this file.
export { history, store };
